(function () {
  function initCounters(root) {
    root.querySelectorAll('[data-pl-count]').forEach(function (input) {
      var field = input.closest('.pl-field');
      var counter = field && field.querySelector('[data-pl-counter]');
      if (!counter) return;
      var update = function () {
        counter.textContent = input.value.length;
      };
      input.addEventListener('input', update);
      update();
    });
  }

  function initCard(root) {
    var form = document.getElementById(root.dataset.formId);
    var card = root.querySelector('[data-pl-card]');
    var mapEl = root.querySelector('[data-pl-variants]');
    if (!form || !card || !mapEl) return;

    var map = {};
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }

    var sync = function () {
      var idInput = form.querySelector('input[name="id"]');
      var isComplete = !!(idInput && map[idInput.value]);
      card.hidden = !isComplete;
      card.querySelectorAll('[data-pl-card-input]').forEach(function (el) {
        el.disabled = !isComplete;
        if (el.hasAttribute('data-pl-card-required')) el.required = isComplete;
      });
    };

    sync();
    document.addEventListener('change', function () {
      setTimeout(sync, 50);
      setTimeout(sync, 600);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(sync, 0);
      });
    }
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-pl-sticky]');
    var target = document.querySelector('[data-pl-personalize]');
    var buyButton = document.querySelector('.product-form__submit');
    if (!bar || !target || !buyButton || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      var below = entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', !visible && below);
    });
    observer.observe(buyButton);

    bar.querySelector('button').addEventListener('click', function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var first = target.querySelector('input[type="text"], select');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 500);
    });
  }

  function initShowWhen(root) {
    root.querySelectorAll('[data-pl-show-when]').forEach(function (field) {
      var rule = field.getAttribute('data-pl-show-when');
      var idx = rule.indexOf(':');
      var selectName = rule.slice(0, idx);
      var value = rule.slice(idx + 1);
      var group = root.querySelector('[data-pl-select="' + selectName + '"]');
      if (!group) return;
      var sync = function () {
        var on = group.value === value;
        field.hidden = !on;
        field.querySelectorAll('input, textarea, select').forEach(function (el) {
          el.disabled = !on;
          if (el.hasAttribute('data-pl-required')) el.required = on;
        });
      };
      group.addEventListener('change', sync);
      sync();
    });
  }

  function clearError(field) {
    if (!field) return;
    field.classList.remove('is-invalid');
    var msg = field.querySelector('.pl-error');
    if (msg) msg.remove();
  }

  function showError(field, text) {
    if (!field || field.classList.contains('is-invalid')) return;
    field.classList.add('is-invalid');
    var msg = document.createElement('p');
    msg.className = 'pl-error';
    msg.setAttribute('role', 'alert');
    msg.textContent = text;
    field.appendChild(msg);
  }

  function initValidation(root) {
    var form = document.getElementById(root.dataset.formId);
    if (!form) return;
    root.addEventListener('input', function (e) {
      clearError(e.target.closest('.pl-field, .pl-check'));
    });
    root.addEventListener('change', function (e) {
      clearError(e.target.closest('.pl-field, .pl-check'));
    });
    document.addEventListener(
      'submit',
      function (e) {
        if (e.target !== form) return;
        var invalid = [];
        root.querySelectorAll('input, textarea, select').forEach(function (el) {
          if (el.disabled || !el.willValidate) return;
          if (!el.checkValidity()) invalid.push(el);
        });
        if (!invalid.length) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        invalid.forEach(function (el) {
          var field = el.closest('.pl-field, .pl-check');
          var text = el.type === 'checkbox' ? 'Please confirm the spelling before adding to cart.' : el.tagName === 'SELECT' ? 'Please choose one.' : 'Please fill this in.';
          showError(field, text);
        });
        var first = invalid[0];
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('[data-pl-personalize]').forEach(function (root) {
      initCounters(root);
      initCard(root);
      initShowWhen(root);
      initValidation(root);
    });
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
